import { createBrowserRouter } from "react-router";

import { Clothing } from "../pages/Clothing";
import { ClothingDetail } from "../pages/ClothingDetail";
import { ErrorPage } from "../pages/ErrorPage";
import { Home } from "../pages/Home";
import { NotFound } from "../pages/NotFound";

export const router = createBrowserRouter([
  {
    index: true,
    Component: Clothing,
  },
  {
    path: "home",
    Component: Home,
  },
  {
    path: "clothing",
    Component: Clothing,
  },
  {
    path: "clothing/:id",
    Component: ClothingDetail,
  },
  {
    path: "*",
    element: <NotFound />,
    errorElement: <ErrorPage />,
  },
]);
